// Strip all space characters
export function stripSpaces(value) {
  return (value || "").replace(/\s/g, "");
}